import { render, staticRenderFns } from "./BaseRequireAction.vue?vue&type=template&id=085832a0&"
import script from "./BaseRequireAction.vue?vue&type=script&lang=js&"
export * from "./BaseRequireAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports